import { render, staticRenderFns } from "./TeachActivityInfo.vue?vue&type=template&id=07464c11&scoped=true"
import script from "./TeachActivityInfo.vue?vue&type=script&lang=js"
export * from "./TeachActivityInfo.vue?vue&type=script&lang=js"
import style0 from "./TeachActivityInfo.vue?vue&type=style&index=0&id=07464c11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07464c11",
  null
  
)

export default component.exports